import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faStar } from '@fortawesome/free-regular-svg-icons';

import {
  faBars,
  faCalendarAlt,
  faCircleExclamation,
  faEnvelope,
  faGift,
  faLocationDot,
  faMobileAlt,
  faPhone,
  faSquareParking,
  faWifi,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faBars,
  faCalendarAlt,
  faMobileAlt,
  faCircleExclamation,
  faWifi,
  faSquareParking,
  faFacebook,
  faGift,
  faPhone,
  faEnvelope,
  faLocationDot,
  faStar
);

export default FontAwesomeIcon;
